module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree"
  }, [_c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "accordion": false,
      "node-key": "Id",
      "default-expanded-keys": _vm.defaultExpandedKeys,
      "highlight-current": true,
      "data": _vm.DataList,
      "props": _vm.defaultProps,
      "effect": "dark",
      "content": "Right Bottom 提示文字",
      "placement": "right-end",
      "element-loading-text": "拼命加载中"
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e975f45!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Tree/Tree.vue
// module id = 1463
// module chunks = 1